import * as React from 'react';
import {MultipleImageFormatType} from '../../../models/chatChannelModel/message/format';
import {styled} from '../../../utils';
import Flex from '../../Flex';
import ChatMessage from '../ChatMessage';

interface MultipleImageMessageProps {
  message: ChatMessage<MultipleImageFormatType>;
}

const ImageElement = styled('img')({
  width: '100px',
  height: '100px',
  marginLeft: 20,
  marginTop: 20,
  marginBottom: 20,
  borderRadius: 5
});

export default class MultipleImageMessage extends React.Component<
  MultipleImageMessageProps,
  {}
> {
  public render() {
    const linkImages = this.props.message.format.attachment.payload.urls;
    return (
      <Flex style={{marginLeft: 60}}>
        {linkImages.map((imgSrc, index) => (
          <ImageElement src={imgSrc} key={index} />
        ))}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/MultipleImageMessage/MultipleImageMessage.tsx